export default class RequestError extends Error {
  constructor(code, message, errorObj) {
    super(message);
    this.name = 'RequestError';
    this.code = code;
    this.errorObj = errorObj;
  }
}
